import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';

function uniqueId(): string {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

@Injectable()
export class ConfigureService {
    configFile = 'config.json';
    params: any;
    paramsLoaded = new EventEmitter();

    constructor(private http: HttpClient) {}

    load(): Promise<any> {
        return this.http.get(`${this.configFile}?t=${uniqueId()}`)
            .toPromise()
            .then(params => {
                this.params = params;
                this.paramsLoaded.emit(params);
            }, () => {
                throw new Error(`${this.configFile} could not be loaded / found`);
            });
    }
}
